export const getIsPosting = state => state.getIn(['casesReceipt', 'isPosting']);
export const getErrMsg = state => state.getIn(['casesReceipt', 'errMsg']);

export const getExportReceipt = state => state.getIn(['casesReceipt', 'casesReceipt']);
export const getLawer = state => state.getIn(['casesReceipt', 'lawer']);